// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../common/ViewStack.bs.js");
let ReactRender = require("../../utils/ReactRender.bs.js");
let ClickOutside = require("../../common/ClickOutside.bs.js");
let TailwindMerge = require("tailwind-merge");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function SearchComponents$MenuItem$OpenItem(props) {
  let tmp;
  tmp = props.position === "Right" ? "right-0" : "";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
      paddingFull: true,
      hasShadow: true,
      hasBorder: true,
      children: props.children
    }),
    className: TailwindMerge.twMerge([
      "absolute z-20",
      tmp
    ])
  });
}

let OpenItem = {
  make: SearchComponents$MenuItem$OpenItem
};

function SearchComponents$MenuItem(props) {
  let __position = props.position;
  let __showIcon = props.showIcon;
  let showIcon = __showIcon !== undefined ? __showIcon : true;
  let position = __position !== undefined ? __position : "Left";
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  let isOpen = match[0];
  let tmp;
  tmp = position === "Right" ? "relative" : "";
  return JsxRuntime.jsxs(ClickOutside.make, {
    fullSize: false,
    onClickOutside: () => setIsOpen(param => false),
    children: [
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => setIsOpen(p => !p),
        size: "small",
        ariaExpanded: isOpen,
        id: props.id,
        children: JsxRuntime.jsxs(ViewStack.make, {
          space: "sm",
          alignItems: "center",
          flexDirection: "row",
          children: [
            props.title,
            showIcon ? JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: isOpen ? "arrow-up" : "arrow-down",
                  size: 12
                }),
                "aria-hidden": true,
                className: "flex ml-1.5"
              }) : null
          ]
        })
      }),
      ReactRender.ifTrue(JsxRuntime.jsx(SearchComponents$MenuItem$OpenItem, {
        children: props.children,
        position: position
      }), isOpen)
    ],
    className: tmp
  });
}

let MenuItem = {
  OpenItem: OpenItem,
  SecondaryButton: undefined,
  make: SearchComponents$MenuItem
};

exports.MenuItem = MenuItem;
/* react Not a pure module */
